import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { Grid, Tab, Tabs } from "@mui/material";
import {
  getExportErrorMessage,
  getExportFileName,
  downloadBlob,
} from "../Reports/ReportPage";
import TabPanel from "../../common/TabPanel/TabPanel";
import CreateDistributorModal from "../../common/Modal/Distributor/CreateDistributorModal";
import CreateEnterpriseModal from "../../common/Modal/Enterprise/CreateEnterpriseModal";
import "../Distributors/DistributorProfile.css";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { a11yProps } from "../../common/TabPanel/a11yProps";
import InternalUsers from "./InternalUsers/InternalUsers";
import AddEditInternalUserModal from "../../common/Modal/InternalUsers/AddEditInternalUserModal";
import { toast } from "react-toastify";
import { usePageMode } from "../../hooks/usePageMode";
import { useAuth } from "../../hooks/useAuth";
import { getServiceInstance } from "../../services/UserServices/UserService";
import { useLoading } from "../../hooks/useLoader";
import { useMasterData } from "../../hooks/useMasterData";
import ExportToExcelHandler from "../../utilities/ExportToExcelHandler";
import {
  GetAllSelectedIds,
  ClearSelectionData,
  GetSelectedColumns,
  getSelectedCols,
} from "../../utilities/SelectionFilter";
import Content from "./Content/Content";
import Catalog from "./Catalog/Catalog";
import { MODE, TABS } from "../../constants/common";
import { FILTER_OPTION } from "../../constants/filterOptions";
import { useDistributorProfileContext } from "./DistributorProfile.context";
import { useContentContext } from "./Content/Content.context";
import { useCatalogContext } from "./Catalog/Catalog.context";
import {
  PermissionService,
  PermissionEnum,
  getModuleId,
  childModulePermissions,
  enabledTabs,
  hasModulePermission,
} from "../../constants/permissionService";
import { DocumentType } from "./constants";
import Bundle from "./Bundle/Bundle";
import { useBundleContext } from "./Bundle/Bundle.context";
import {
  SystemModulesEnum,
  SystemUsersEnum,
} from "../../constants/SystemUsers";
import BasicInfo from "../../common/BasicInformation/BasicInfo";
import ApiServices from "../../services/ApiServices";
import {
  ALL_ROLE_LIST,
  ENTERPRISE,
  AD_EXPORT,
} from "../../constants/api-constants";
import { getSecureRandomInt } from "../../utilities/secureRandom";
import Access from "./SubscriberAccess/Access";
import { UserTypes } from "../../constants/user-types";
import PropTypes from "prop-types";
import AddInsServicesList from "./AddInsServices/AddInsServicesList";
import AddInsServicesTab from "./AddInsServicesTab";
import AdManagementList from "../AdManagement/AdManagementList";
import {
  isEnterpriseUserRole,
  isSuperAdminOrAdminRole,
} from "../../utilities/UserRoleUtils";

const mergeEnterpriseOptions = (newOptions, prevOptions) => {
  const prevEnterprise = prevOptions.find(
    (p) => p.field === "enterpriseGroupIds",
  );
  return newOptions.map((opt) =>
    opt.field === "enterpriseGroupIds"
      ? { ...opt, options: prevEnterprise?.options ?? [] }
      : opt,
  );
};

/*istanbul ignore next */
const DistributorProfile = (props) => {
  const { bulkUploadTemplate } = props.routeData;
  const [formData, setFormData] = useState({
    systemGeneratedId: "",
    userTypeId: props.routeData?.userTypeId,
    firstName: "",
    lastName: "",
    brandName: "",
    primaryEmail: "",
    secondaryEmail: "",
    phoneNumber: "",
    secondaryPhoneNumber: "",
    distributorType: [],
    areas: [],
    carrierRepresents: [],
    carriers: [],
    industryGroups: [],
    technologies: [],
    annualRevenue: "",
    billingContact: "",
    billingContactLastName: "",
    businessYear: "",
    websiteUrl: "",
    numberOfEmployees: "",
    numberOfOwners: "",
    producers: "",
    userTypeName: "",
    billingPhoneNumber: "",
    billingAddressLine1: "",
    billingAddressLine2: "",
    businessName: "",
    taxID: null,
    zip: "",
    countryId: 1,
    city: "",
    state: "0",
    mobile: "",
    mobile1: "",
    fax: "",
    fax1: "",
    status: 1,
    egSubscriptions: [],
    parentUser: {
      parentUserId: 0,
      permissions: [],
    },
    associateDistributors: [],
    roles: [],
    distributorSubscriptionDomains: [],
    dirty: false,
    enterpriseIds: [],
    distributorIds: [],
    userAddOns: [],
    logoGcpPath: "",
    logoGcpFileUrl: "",
    signUpApproval: null,
  });
  const masterDataContext = useMasterData();
  const distributorProfileContext = useDistributorProfileContext();
  const contentContext = useContentContext();
  const catalogContext = useCatalogContext();
  const bundleContext = useBundleContext();
  const location = useLocation();
  const { id, tabId } = useParams();
  const [selectedTab, setSelectedTab] = useState(TABS.BASIC);
  const [selectedSubTab, setSelectedSubTab] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [createUserView, setCreateUserView] = useState(false);
  const [userRoles, setUserRoles] = React.useState({});
  const [internalFilterOptions, setInternalFilterOptions] = React.useState(
    FILTER_OPTION.INTERNALUSER_LIST,
  );
  const [contentFilterOptions, setContentFilterOptions] = React.useState(
    FILTER_OPTION.DISTRIBUTOR_CONTENT_LIST,
  );
  const [catalogFilterOptions, setCatalogFilterOptions] = React.useState(
    FILTER_OPTION.DISTRIBUTOR_CATALOG_LIST,
  );
  const [bundleFilterOptions, setBundleFilterOptions] = React.useState(
    FILTER_OPTION.DISTRIBUTOR_BUNDLE_LIST,
  );
  const [adManagementQuery, setAdManagementQuery] = useState({
    searchText: "",
    SortType: "desc",
    SortColumn: "createdOn",
    PageNumber: 1,
    PageSize: 10,
    filter: {},
  });
  const adManagementFilterOptions = FILTER_OPTION.AD_MANAGEMENT_LIST;
  const [adManagementTriggerAdd, setAdManagementTriggerAdd] = useState(false);
  /* Tracks the AdManagementList inner mode (LIST / ADD / EDIT / VIEW) so the
   * BasicInfo header can hide Create / Filter / Export icons while the
   * Add/Edit/View Ad form is open. */
  const [adManagementMode, setAdManagementMode] = useState(MODE.LIST);
  const [typecontentListOptions, settypecontentListOptions] = React.useState(
    FILTER_OPTION.TYPE_OF_CONTENT_LIST,
  );
  const [refreshData, setRefreshData] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState(null);
  const [loaded, setLoaded] = useState(false);
  const [contentMode, setContentMode] = useState(contentContext.contentMode);
  const [contentId, setContentId] = useState(contentContext.contentId);
  const [catalogMode, setCatalogMode] = useState(catalogContext.catalogMode);
  const [catalogId, setCatalogId] = useState(catalogContext.catalogId);
  const [bundleMode, setBundleMode] = useState(bundleContext.bundleMode);
  const [bundleId, setBundleId] = useState(bundleContext.bundleId);
  const [tabPermissions, setTabPermissions] = useState([]);
  const [parentPermissions, setParentPermissions] = useState([]);
  const [tableColumnModalVisibility, setTableColumnModalVisibility] =
    useState(false);
  const [
    tableColumnModalVisibilityInternal,
    setTableColumnModalVisibilityInternal,
  ] = useState(false);

  const auth = useAuth();
  const { showLoader } = useLoading();

  const userService = getServiceInstance(props.routeData?.userTypeId);
  const roleId = auth.getRole();

  const setRefreshCallBack = (status) => {
    setRefreshData(status);
  };
  const handleCloseModalCallback = () => {
    setCreateUserView(false);
  };

  const [query, setQuery] = useState({
    searchText: "",
    SortType: "desc",
    SortColumn: "userId",
    PageNumber: 1,
    PageSize: 10,
    filter: {
      userStatus: [0, 1],
      roles: [],
      selectedColumns: [],
    },
  });
  const initialContentQuery = {
    searchText: "",
    SortType: "desc",
    SortColumn: "isFavorite",
    PageNumber: 1,
    PageSize: 10,
    filter: {
      lineOfBusinessList: [],
      typeOfFormList: [],
      selectedColumns: [],
      contentType: [],
      status: [],
      publishStatus: "",
      catalogType: [],
      bundleType: [],
      contentAssociationStatus: [],
      selectedContentOriginators: [],
      isShareableViaReusableLink: null,
      enterpriseGroupIds: [],
    },
  };
  const [contentQuery, setContentQuery] = useState(initialContentQuery);

  const history = useHistory();
  const page = usePageMode();

  const permissions = PermissionService(
    getModuleId(props?.routeData?.userTypeId),
  );

  const allUsersExportPermission =
    (selectedTab === TABS.INTERNAL_USERS ||
      selectedTab === TABS.CONTENT ||
      selectedTab === TABS.CATALOG ||
      selectedTab === TABS.BUNDLE ||
      selectedTab === TABS.AD_MANAGEMENT) &&
    (roleId === 1 ||
      roleId === 2 ||
      roleId === 3 ||
      roleId === 4 ||
      roleId === 5 ||
      roleId === 6);
  const addInternalUserFormData = {
    firstName: "",
    lastName: "",
    primaryEmail: "",
    secondaryEmail: "",
    phoneNumber: "",
    secondaryPhoneNumber: "",
    userTypeId: "",
    userId: "",
    systemGeneratedId: "",
    status: true,
  };

  const getSeletedSubModule = () => {
    const userPathRole = getPathRole(roleId, props);

    let selectedSubModule = switchByTab(selectedTab, userPathRole);

    return selectedSubModule;
  };

  useEffect(() => {
    const currentTabPermissions = childModulePermissions(
      getModuleId(props?.routeData?.userTypeId),
      getSeletedSubModule(),
    );
    setTabPermissions(currentTabPermissions);
  }, [selectedTab]);

  useState(() => {
    setCurrentUser(auth.getCurrentUser());
  }, [auth.currentUser]);

  const getEditData = async (userId) => {
    if (userId > 0) {
      try {
        showLoader(true);
        let user = await userService.getUser(userId);
        showLoader(false);
        if (user?.associateDistributors) {
          let retVal = user.associateDistributors.map((el) => {
            return {
              ...el,
              uid: getSecureRandomInt(1000),
              distributorUserId: {
                value: el.distributorUserId,
                label: el.brandName || "",
              },
              associationId: el.associationId,
              frequencyType: el.frequencyType,
              isRecurring: el.isRecurring,
              isNewAssociation: el.isNewAssociation,
              expirationDate: el.expirationDate,
              distributorSubscriptionId: el.distributorSubscriptionId,
              associatonStatus: el.associatonStatus,
              requestId: el.requestId,
              enterpriseUserId: el.enterpriseUserId,
              subscriptionTypes: [],
              isStopped: el.isStopped,
              startDate: el.startDate,
              endDate: el.stoppedDate,
              status: el.status,
              isSubscriberAssociate: el.isSubscriberAssociate,
              isFutureSubscription: el.isFutureSubscription,
              subscriptionStatus: el.subscriptionStatus,
              distributorSubscriptionPlanId: el.distributorSubscriptionPlanId,
            };
          });
          user = {
            ...user,
            associateDistributors: [...retVal],
          };
        } else {
          user.isDirty = false;
        }

        if (user?.distributorSubscriptionDomains) {
          let retVal = user.distributorSubscriptionDomains?.map((el) => {
            return {
              ...el,
              uid: getSecureRandomInt(1000),
              distributorSubscriptionId: el.distributorSubscriptionId,
              name: el.name,
              status: el.status,
              subscriptionPlan: el.subscriptionPlan?.map((el) => {
                return {
                  uniqueId: getSecureRandomInt(1000),
                  baseValue: el.baseValue?.toFixed(2),
                  status: el.status,
                  distributorSubscriptionPlanId:
                    el.distributorSubscriptionPlanId,
                  distributorSubscriptionId: el.distributorSubscriptionId,
                  effectiveFromDate: el.effectiveFromDate,
                  effectiveToDate: el.effectiveToDate,
                  savedEffectiveToDate: el.effectiveToDate,
                  frequency: el.frequency,
                  isAssociated: el.isAssociated,
                };
              }),
            };
          });
          user = {
            ...user,
            distributorSubscriptionDomains: [...retVal],
          };
        }
        setFormData(user);
      } catch (e) {
        showLoader(false);
      }
    }
  };
  const loadDropndownOption = async () => {
    try {
      showLoader(true);
      const response = masterDataContext.masterDataValue;
      showLoader(false);
      const bundleOptions = [...bundleFilterOptions];

      // LOB
      bundleOptions[2].options = response.result.lineOfBusiness.map((r) => {
        return {
          value: r.lineOfBusinessId,
          roleId: r.lineOfBusinessId,
          label: r.name,
        };
      });
      // Type of Form
      bundleOptions[6].options = response.result.typeOfForm.map((r) => {
        return {
          value: r.typeOfFormId,
          roleId: r.typeOfFormId,
          label: r.name,
        };
      });
      // Countries
      bundleOptions[1].options = response.result.countries.map((r) => {
        return {
          value: r.countryId,
          roleId: r.countryId,
          label: r.name,
        };
      });

      // State
      bundleOptions[4].options = response.result.states.map((r) => {
        return {
          value: r.stateId,
          roleId: r.stateId,
          label: r.name,
        };
      });
      setBundleFilterOptions((prev) =>
        mergeEnterpriseOptions(bundleOptions, prev),
      );
      setParentPermissions(response.result.parentPermissions);
    } catch (e) {
      showLoader(false);
    }
  };

  useEffect(() => {
    if (!loaded) {
      loadDropndownOption();
      setLoaded(true);
    }
    page.setBreadcrumbRootNode({
      title: props.routeData?.title,
      path: props.routeData?.listRoute,
    });
  }, []);

  const loadDropdownOption = async () => {
    try {
      showLoader(true);
      const response = masterDataContext.masterDataValue;
      showLoader(false);
      const catalogOptions = [...catalogFilterOptions];

      // LOB
      catalogOptions[2].options = response.result.lineOfBusiness.map((r) => {
        return {
          value: r.lineOfBusinessId,
          roleId: r.lineOfBusinessId,
          label: r.name,
        };
      });
      // Type of Form
      catalogOptions[6].options = response.result.typeOfForm.map((r) => {
        return {
          value: r.typeOfFormId,
          roleId: r.typeOfFormId,
          label: r.name,
        };
      });
      // Countries
      catalogOptions[1].options = response.result.countries.map((r) => {
        return {
          value: r.countryId,
          roleId: r.countryId,
          label: r.name,
        };
      });

      // State
      catalogOptions[4].options = response.result.states.map((r) => {
        return {
          value: r.stateId,
          roleId: r.stateId,
          label: r.name,
        };
      });
      setCatalogFilterOptions((prev) =>
        mergeEnterpriseOptions(catalogOptions, prev),
      );
      setParentPermissions(response.result.parentPermissions);
    } catch (e) {
      showLoader(false);
    }
  };

  useEffect(() => {
    if (!loaded) {
      loadDropdownOption();
      setLoaded(true);
    }
  }, []);

  const loadDropdownlistOption = async () => {
    try {
      showLoader(true);
      const response = masterDataContext.masterDataValue;
      showLoader(false);
      const typecontentOptions = [...typecontentListOptions];

      // LOB
      typecontentOptions[4].options = response.result.lineOfBusiness.map(
        (r) => {
          return {
            value: r.lineOfBusinessId,
            roleId: r.lineOfBusinessId,
            label: r.name,
          };
        },
      );
      // Type of Form
      typecontentOptions[9].options = response.result.typeOfForm.map((r) => {
        return {
          value: r.typeOfFormId,
          roleId: r.typeOfFormId,
          label: r.name,
        };
      });
      // Countries
      typecontentOptions[3].options = response.result.countries.map((r) => {
        return {
          value: r.countryId,
          roleId: r.countryId,
          label: r.name,
        };
      });

      // State
      typecontentOptions[7].options = response.result.states.map((r) => {
        return {
          value: r.stateId,
          roleId: r.stateId,
          label: r.name,
        };
      });
      settypecontentListOptions(typecontentOptions);
    } catch (e) {
      showLoader(false);
    }
  };

  useEffect(() => {
    if (!loaded) {
      loadDropdownlistOption();
      setLoaded(true);
    }
  }, []);

  const setContentOriginators = async (list) => {
    const contentOptions = [...contentFilterOptions];
    let originators = contentOptions.find(
      (x) => x.field === "contentOriginators",
    );
    originators.options = list.map((r) => {
      return {
        value: r,
        roleId: r,
        label: r,
      };
    });
    setContentFilterOptions(contentOptions);
  };
  const loadDropndownOptions = async () => {
    try {
      showLoader(true);
      const adminData = await ApiServices.httpGet(`${ALL_ROLE_LIST}`);
      const response = masterDataContext.masterDataValue;
      showLoader(false);
      let roles =
        props.routeData.userRolesKey === "distributorInternalUserRoles"
          ? adminData?.result?.records?.filter(
              (res) =>
                res.roleTypes &&
                res.roleTypes.length > 0 &&
                res.roleTypes[0]?.userType ===
                  SystemUsersEnum.DISTRIBUTOR_INTERNAL,
            )
          : adminData?.result?.records?.filter(
              (res) =>
                res.roleTypes?.length > 0 &&
                res.roleTypes[0]?.userType ===
                  SystemUsersEnum.ENTERPRISE_INTERNAL,
            );
      setUserRoles(roles);
      const internalOptions = [...internalFilterOptions];
      internalOptions[0].options = roles.map((r) => {
        return {
          value: r.roleId,
          roleId: r.roleId,
          label: r.name,
        };
      });
      setInternalFilterOptions(internalOptions);

      const contentOptions = [...contentFilterOptions];
      // LOB
      contentOptions[4].options = response.result.lineOfBusiness.map((r) => {
        return {
          value: r.lineOfBusinessId,
          roleId: r.lineOfBusinessId,
          label: r.name,
        };
      });
      // Type of Form
      contentOptions[10].options = response.result.typeOfForm.map((r) => {
        return {
          value: r.typeOfFormId,
          roleId: r.typeOfFormId,
          label: r.name,
        };
      });
      // Countries
      contentOptions[3].options = response.result.countries.map((r) => {
        return {
          value: r.countryId,
          roleId: r.countryId,
          label: r.name,
        };
      });

      // State
      contentOptions[7].options = response.result.states.map((r) => {
        return {
          value: r.stateId,
          roleId: r.stateId,
          label: r.name,
        };
      });

      //Content Originator
      let originators = contentOptions.find(
        (x) => x.field === "contentOriginators",
      );
      originators.options = [];
      setContentFilterOptions((prev) =>
        mergeEnterpriseOptions(contentOptions, prev),
      );
      setParentPermissions(response.result.parentPermissions);
    } catch (e) {
      showLoader(false);
    }
  };

  useEffect(() => {
    setSelectedTab(tabId || TABS.BASIC);
    getEditData(id);
    setContentQuery(initialContentQuery);
  }, [id, tabId]);

  useEffect(() => {
    if (!loaded) {
      loadDropndownOptions();
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (formData.parentUser.permissions?.length === 0) {
      setFormData({
        ...formData,
        parentUser: {
          ...formData.parentUser,
          permissions: parentPermissions,
        },
      });
    }
  }, [parentPermissions]);

  const loadEnterpriseFilterOptions = async (filterBy, setOptions) => {
    try {
      const response = await ApiServices.httpGet(
        `${ENTERPRISE}?filterBy=${filterBy}&userId=${id}`,
      );
      if (response?.responseStatus?.isSuccess) {
        const enterpriseOptions = (response.result || [])
          .map((r) => ({
            value: r.userId,
            roleId: r.userId,
            label: r.brandName || r.name || "NA",
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setOptions((prev) =>
          prev.map((opt) =>
            opt.field === "enterpriseGroupIds"
              ? { ...opt, options: enterpriseOptions }
              : opt,
          ),
        );
      }
    } catch (e) {
      // silently ignore
    }
  };

  useEffect(() => {
    if (tabId === TABS.CONTENT) {
      loadEnterpriseFilterOptions("CONTENT", setContentFilterOptions);
    } else if (tabId === TABS.CATALOG) {
      loadEnterpriseFilterOptions("CATALOG", setCatalogFilterOptions);
    } else if (tabId === TABS.BUNDLE) {
      loadEnterpriseFilterOptions("BUNDLE", setBundleFilterOptions);
    }
  }, [tabId, id]);

  const handleHandleChange = (event, newValue) => {
    /* If a dirty-form guard is registered (e.g. Ad Add/Edit with unsaved
       changes), let it intercept and only proceed with the tab switch
       once the user resolves the prompt. */
    if (page.onDirtyNavigation) {
      page.onDirtyNavigation(() => performTabChange(newValue));
      return;
    }
    performTabChange(newValue);
  };

  const performTabChange = (newValue) => {
    setQuery({
      ...query,
      filter: {
        ...query.filter,
        userStatus: [0, 1],
      },
    });
    setContentQuery((prevState) => ({
      ...prevState,
      filter: {
        ...prevState.filter,
        status: [],
        contentType: [],
        published: "null",
        countries: [],
        states: [],
        lineOfBusiness: [],
        typeOfForm: [],
        contentAssociationStatus: [],
        TypeOfContent: [],
        selectedContentOriginators: [],
      },
    }));
    contentContext.setContentMode(MODE.LIST);
    catalogContext.setCatalogMode(MODE.LIST);
    bundleContext.setBundleMode(MODE.LIST);
    if (formData.userId > 0) {
      history.push(
        `${props.routeData.editRoute.replace(
          ":id",
          formData.userId,
        )}/${newValue}`,
      );
    }
    distributorProfileContext.setSelectedTab(newValue);
    setSelectedTab(newValue);
    if (newValue === TABS.CONTENT) {
      loadEnterpriseFilterOptions("CONTENT", setContentFilterOptions);
    } else if (newValue === TABS.CATALOG) {
      loadEnterpriseFilterOptions("CATALOG", setCatalogFilterOptions);
    } else if (newValue === TABS.BUNDLE) {
      loadEnterpriseFilterOptions("BUNDLE", setBundleFilterOptions);
    }
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleContinueToUpdateBasicInfo = () => {
    distributorProfileContext.setSelectedTab(TABS.BASIC);
    setSelectedTab(TABS.BASIC);
    page.setEditMode(true);
    if (formData.userId > 0) {
      history.push(props.routeData.editRoute.replace(":id", formData.userId));
    }
  };

  const validateBasicInformationBeforeCreate = async () => {
    const validationSchema =
      props?.routeData?.basicInformationSchema || props?.routeData?.schema;
    if (!validationSchema) return true;

    const userId = formData.userId || Number(id);
    let latestFormData = formData;

    if (userId > 0) {
      try {
        showLoader(true);
        const latestUser = await userService.getUser(userId);
        showLoader(false);
        latestFormData = { ...formData, ...latestUser };
      } catch (_error) {
        showLoader(false);
        // eslint-disable-next-line no-console
        console.log("Basic information validation failed", [
          {
            field: "profile",
            message: "Unable to load latest profile data",
          },
        ]);
        return false;
      }
    }

    const validationValues = {
      ...latestFormData,
      isShippingAddressSameAsBilling:
        typeof latestFormData.isShippingAddressSameAsBilling === "boolean"
          ? latestFormData.isShippingAddressSameAsBilling
          : true,
      shippingContactName: latestFormData.shippingContactName || "",
      shippingContactLastName: latestFormData.shippingContactLastName || "",
      shippingPhoneNumber: latestFormData.shippingPhoneNumber || "",
      shippingAddressLine1: latestFormData.shippingAddressLine1 || "",
      shippingAddressLine2: latestFormData.shippingAddressLine2 || "",
      shippingCountryId: latestFormData.shippingCountryId || null,
      shippingStateId: latestFormData.shippingStateId || null,
      shippingCity: latestFormData.shippingCity || "",
      shippingZipCode: latestFormData.shippingZipCode || "",
      isSmsConsentGiven: latestFormData.isSmsConsentGiven || false,
    };

    try {
      await validationSchema.validate(validationValues, { abortEarly: false });
      return true;
    } catch (validationError) {
      const validationErrors = validationError?.inner?.length
        ? validationError.inner
        : [validationError];
      const validationIssues = validationErrors.map((error) => ({
        field: error.path,
        message: error.message,
        type: error.type,
      }));
      const schemaFields = validationSchema.describe()?.fields || {};
      const requiredSchemaIssues = validationIssues.filter((error) =>
        schemaFields[error.field]?.tests?.some(
          (test) => test.name === "required",
        ),
      );

      return requiredSchemaIssues.length === 0;
    }
  };

  const applyInternalFilterHandler = (filter) => {
    ClearSelectionData();
    setQuery((prevState) => {
      return {
        ...prevState,
        filter: {
          ...prevState.filter,
          userStatus: filter.status,
          AccountStatus: filter.accountStatus,
          roles: filter.role?.map((r) => {
            return { roleId: r };
          }),
        },
      };
    });
  };

  const applytypecontentFilterHandler = (filter) => {
    ClearSelectionData();
    setContentQuery((prevState) => {
      const shareable = filter?.isShareableViaReusableLink;
      const restrictedValue =
        shareable?.length !== 1 || shareable?.includes("All")
          ? null
          : (shareable?.[0] ?? null);
      return {
        ...prevState,
        filter: {
          ...prevState.filter,
          lineOfBusiness:
            filter?.lineOfBusiness?.map((item) => ({
              lineOfBusinessId: item,
            })) ?? [],
          typeOfForm:
            filter?.typeOfForm?.map((item) => ({
              typeOfFormId: item,
            })) ?? [],
          countries:
            filter?.countries?.map((item) => ({
              countryId: item,
            })) ?? [],
          states:
            filter?.states?.map((item) => ({
              stateId: item,
            })) ?? [],
          contentType: filter?.contentType?.map((item) => item) ?? [],
          status: filter?.status?.map((item) => item) ?? [],
          contentAssociationStatus:
            filter?.contentAssociationStatus?.map((item) => item) ?? [],
          publishStatus: filter?.publishStatus?.map((item) => item) ?? [],
          contentFillable: filter?.contentFillable,
          selectedContentOriginators: filter?.contentOriginators ?? [],
          isShareableViaReusableLink: restrictedValue,
        },
      };
    });
  };

  const applyContentFilterHandler = (filter) => {
    ClearSelectionData();
    setContentQuery((prevState) => {
      const restrictedValue =
        filter?.isShareableViaReusableLink?.length === 1 &&
        !filter.isShareableViaReusableLink.includes("All")
          ? filter.isShareableViaReusableLink[0]
          : null;
      return {
        ...prevState,
        filter: {
          ...prevState.filter,
          lineOfBusiness:
            filter?.lineOfBusiness?.map((item) => ({
              lineOfBusinessId: item,
            })) ?? [],
          typeOfForm:
            filter?.typeOfForm?.map((item) => ({
              typeOfFormId: item,
            })) ?? [],
          countries:
            filter?.countries?.map((item) => ({
              countryId: item,
            })) ?? [],
          states:
            filter?.states?.map((item) => ({
              stateId: item,
            })) ?? [],
          contentType: filter?.contentType?.map((item) => item) ?? [],
          status: filter?.status?.map((item) => item) ?? [],
          publishStatus: filter?.publishStatus?.map((item) => item) ?? [],
          TypeOfContent: filter?.TypeOfContent?.map((item) => item) ?? [],
          selectedContentOriginators: filter?.contentOriginators ?? [],
          contentFillable: filter?.contentFillable,
          isShareableViaReusableLink: restrictedValue,
          enterpriseGroupIds:
            filter?.enterpriseGroupIds?.map((item) => item) ?? [],
        },
      };
    });
  };

  const applyAdManagementFilterHandler = (filter) => {
    setAdManagementQuery((prevState) => ({
      ...prevState,
      PageNumber: 1,
      filter: {
        position: filter?.position ?? [],
        payment: filter?.payment ?? [],
        status: filter?.status ?? [],
        startDateFrom: filter?.startDateFrom ?? null,
        startDateTo: filter?.startDateTo ?? null,
      },
    }));
  };

  const onNextHandler = (isNext, user) => {
    if (isNext) {
      history.push(
        `${props.routeData.editRoute.replace(":id", user.userId)}/${
          TABS.INTERNAL_USERS
        }`,
      );
    } else {
      getEditData(user.userId);
    }
  };

  const bulkUploadHandler = () => {
    setRefreshData(true);
  };

  /* Build payload + POST to AD_EXPORT for the Ad Management tab. Mirrors
   * the AD_LIST filter shape and pulls visible export columns from the
   * cached column selection so the spreadsheet matches the on-screen grid. */
  const exportAdManagement = async () => {
    try {
      showLoader(true);
      const selectedIds = GetAllSelectedIds("adManagementId") ?? [];
      const cached = localStorage.getItem("selectedColumns")
        ? JSON.parse(localStorage.getItem("selectedColumns"))
        : null;
      const adCols = cached?.adManagementColumns ?? [];
      const selectedColumns = adCols
        .filter((c) => c.isSelected && c.exportLabel)
        .map((c) => c.exportLabel);
      const q = adManagementQuery || {};
      const payload = {
        isShowChildUserData: true,
        selectedIds,
        selectedGuids: [],
        searchText: q.searchText || "",
        sortColumn: q.SortColumn || "title",
        sortType: q.SortType || "desc",
        documentType: 1,
        filter: {
          distributorId: Number(id),
          statusFilter: q.filter?.status ?? [],
          paymentStatusFilter: q.filter?.payment ?? [],
          bannerPositions: q.filter?.position ?? [],
          startDateFrom: q.filter?.startDateFrom ?? null,
          startDateTo: q.filter?.startDateTo ?? null,
          searchText: q.searchText || "",
          selectedIds,
          selectedColumns,
        },
      };
      // Use httpPostRaw and handle response as blob, like exportAdPerformanceReport
      const response = await ApiServices.httpPostRaw(AD_EXPORT, payload);
      if (!response.ok) {
        // getExportErrorMessage and toast.error if available, else fallback
        if (typeof getExportErrorMessage === "function") {
          const serverMessage = await getExportErrorMessage(response);
          toast.error(serverMessage);
        } else {
          toast.error("Failed to export ad management data.");
        }
        return;
      }
      const blob = await response.blob();
      if (!blob || blob.size === 0) {
        toast.error("Failed to export ad management data.");
        return;
      }
      // getExportFileName and downloadBlob if available, else fallback
      let fileName = "ad-management-export.xlsx";
      if (typeof getExportFileName === "function") {
        fileName = getExportFileName(
          response.headers.get("content-disposition"),
        );
      }
      if (typeof downloadBlob === "function") {
        downloadBlob(blob, fileName);
      } else {
        // fallback: create a link and click
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(objectUrl);
      }
      toast.success("Ad Management exported successfully.");
    } catch (e) {
      console.log("ad export error", e);
      toast.error("Internal server error");
    } finally {
      showLoader(false);
      setRefreshCallBack(true);
    }
  };

  const handleExport = async () => {
    try {
      if (selectedTab === TABS.AD_MANAGEMENT) {
        await exportAdManagement();
        return;
      }
      let ids = GetAllSelectedIds(
        selectedTab === TABS.INTERNAL_USERS ? "userId" : "contentId",
      );
      let queryState =
        selectedTab === TABS.INTERNAL_USERS
          ? { ...query }
          : { ...contentQuery };
      queryState.SelectedIds = ids;
      let selectedCols = localStorage.getItem("selectedColumns")
        ? JSON.parse(localStorage.getItem("selectedColumns"))
        : null;
      let tabSelectionData = tabSelections(
        selectedTab,
        selectedCols,
        queryState,
      );
      queryState.filter.selectedColumns = tabSelectionData
        ?.filter((item) => item.isSelected && item.exportLabel !== "")
        .map((r) => r.exportLabel);
      showLoader(true);
      let dataObj = {
        selectedTab: selectedTab,
        queryState: queryState,
        props: props,
        userService: userService,
        id: id,
        contentId: contentId,
        selectedSubTab: selectedSubTab,
        catalogId: catalogId,
        bundleId: bundleId,
        catalogContext: catalogContext,
        bundleContext: bundleContext,
      };
      let exportedContent = await updateBySelectTab(dataObj);

      if (exportedContent?.result?.file) {
        ExportToExcelHandler(
          exportedContent.result.file.fileContents,
          exportedContent.result.file.fileDownloadName,
        );
      } else {
        toast.error(exportedContent?.responseStatus?.error);
      }
      showLoader(false);
      setRefreshCallBack(true);
    } catch (e) {
      showLoader(false);
      console.log("err", e);
      toast.error("Internal server error");
    }
  };

  const onCancelTableColumnSelection = (value) => {
    setTableColumnModalVisibility(value);
  };

  const onCancelTableColumnSelectionInternal = (value) => {
    setTableColumnModalVisibilityInternal(value);
  };

  const searchCallback = (searchTerm) => {
    setQuery({ ...query, searchText: searchTerm });
  };

  const onViewHandler = (content, docType = DocumentType.CONTENT) => {
    if (docType === DocumentType.CATALOG) {
      distributorProfileContext.setSelectedTab(TABS.CATALOG);
      catalogContext.setSelectedTab(TABS.CONTENT_LIST);
      catalogContext.setCatalogMode(MODE.VIEW);
      setCatalogMode(MODE.VIEW);
      catalogContext.setCatalogId(content.contentId);
      setCatalogId(content.contentId);
      catalogContext.setUserId(content.userId);
      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("catalog"),
        )}catalog/${TABS.CONTENT_LIST}`,
      );
    } else if (docType === DocumentType.BUNDLE) {
      distributorProfileContext.setSelectedTab(TABS.BUNDLE);
      bundleContext.setSelectedTab(TABS.CONTENT_LIST);
      bundleContext.setBundleMode(MODE.VIEW);
      setBundleMode(MODE.VIEW);
      bundleContext.setBundleId(content.contentId);
      setBundleId(content.contentId);
      bundleContext.setUserId(content.userId);
      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("bundle"),
        )}bundle/${TABS.CONTENT_LIST}`,
      );
    } else {
      distributorProfileContext.setSelectedTab(TABS.CONTENT);
      setSelectedSubTab(TABS.CONTENT_PREVIEW);
      contentContext.setContentMode(MODE.VIEW);
      setContentMode(MODE.VIEW);
      contentContext.setContentId(content.contentId);
      setContentId(content.contentId);

      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("content"),
        )}content/${TABS.CONTENT_PREVIEW}`,
      );
    }
  };

  const onEditHandler = (content, docType = DocumentType.CONTENT) => {
    if (docType === DocumentType.CATALOG) {
      distributorProfileContext.setSelectedTab(TABS.CATALOG);
      catalogContext.setSelectedTab(TABS.CATALOG_INFORMATION);
      catalogContext.setCatalogMode(MODE.EDIT);
      setCatalogMode(MODE.EDIT);
      catalogContext.setCatalogId(content.contentId);
      setCatalogId(content.contentId);
      catalogContext.setUserId(content.userId);
      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("catalog"),
        )}catalog/${TABS.CATALOG_INFORMATION}`,
      );
    } else if (docType === DocumentType.BUNDLE) {
      distributorProfileContext.setSelectedTab(TABS.BUNDLE);
      bundleContext.setSelectedTab(TABS.BUNDLE_INFORMATION);
      bundleContext.setBundleMode(MODE.EDIT);
      setBundleMode(MODE.EDIT);
      bundleContext.setBundleId(content.contentId);
      setBundleId(content.contentId);
      bundleContext.setUserId(content.userId);
      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("bundle"),
        )}bundle/${TABS.BUNDLE_INFORMATION}`,
      );
    } else {
      distributorProfileContext.setSelectedTab(TABS.CONTENT);
      setSelectedSubTab(TABS.CONTENT_INFORMATION);
      contentContext.setContentMode(MODE.EDIT);
      setContentMode(MODE.EDIT);
      contentContext.setContentId(content.contentId);
      setContentId(content.contentId);

      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("content"),
        )}content/${TABS.CONTENT_INFORMATION}`,
      );
    }
  };
  /*istanbul ignore next */
  const onViewHandlerList = (content, docType = DocumentType.CONTENT) => {
    let location = window.location.pathname.includes("enterprisegroup")
      ? "enterprisegroup"
      : "distributor";
    if (docType === DocumentType.CATALOG) {
      distributorProfileContext.setSelectedTab(TABS.CATALOG);
      catalogContext.setSelectedTab(TABS.CATALOG_INFORMATION);
      catalogContext.setCatalogMode(MODE.VIEW);
      setCatalogMode(MODE.VIEW);
      catalogContext.setCatalogId(content.contentId);
      setCatalogId(content.contentId);
      history.push(`/${location}/${id}/catalog/${TABS.CATALOG_INFORMATION}`);
    } else if (docType === DocumentType.BUNDLE) {
      distributorProfileContext.setSelectedTab(TABS.BUNDLE);
      bundleContext.setSelectedTab(TABS.BUNDLE_INFORMATION);
      bundleContext.setBundleMode(MODE.VIEW);
      setBundleMode(MODE.VIEW);
      bundleContext.setBundleId(content.contentId);
      setBundleId(content.contentId);
      history.push(`/${location}/${id}/bundle/${TABS.BUNDLE_INFORMATION}`);
    } else {
      distributorProfileContext.setSelectedTab(TABS.CONTENT);
      contentContext.setSubSelectedTab(TABS.CONTENT_INFORMATION);
      contentContext.setContentMode(MODE.VIEW);
      setContentMode(MODE.VIEW);
      contentContext.setContentId(content.contentId);
      setContentId(content.contentId);
      history.push(`/${location}/${id}/content/${TABS.CONTENT_INFORMATION}`);
    }
  };
  /*istanbul ignore next */
  const onEditHandlerList = (content, docType = DocumentType.CONTENT) => {
    let location = window.location.pathname.includes("enterprisegroup")
      ? "enterprisegroup"
      : "distributor";
    if (docType === DocumentType.CATALOG) {
      distributorProfileContext.setSelectedTab(TABS.CATALOG);
      catalogContext.setSelectedTab(TABS.CATALOG_INFORMATION);
      catalogContext.setCatalogMode(MODE.EDIT);
      setCatalogMode(MODE.EDIT);
      catalogContext.setCatalogId(content.contentId);
      setCatalogId(content.contentId);
      history.push(`/${location}/${id}/catalog/${TABS.CATALOG_INFORMATION}`);
    } else if (docType === DocumentType.BUNDLE) {
      distributorProfileContext.setSelectedTab(TABS.BUNDLE);
      bundleContext.setSelectedTab(TABS.BUNDLE_INFORMATION);
      bundleContext.setBundleMode(MODE.EDIT);
      setBundleMode(MODE.EDIT);
      bundleContext.setBundleId(content.contentId);
      setBundleId(content.contentId);
      history.push(`/${location}/${id}/bundle/${TABS.BUNDLE_INFORMATION}`);
    } else {
      distributorProfileContext.setSelectedTab(TABS.CONTENT);
      contentContext.setSubSelectedTab(TABS.CONTENT_INFORMATION);
      contentContext.setContentMode(MODE.EDIT);
      setContentMode(MODE.EDIT);
      contentContext.setContentId(content.contentId);
      setContentId(content.contentId);
      history.push(`/${location}/${id}/content/${TABS.CONTENT_INFORMATION}`);
    }
  };

  const onQueryChange = (updatedQuery) => {
    setContentQuery(updatedQuery);
  };

  const onCopyHandler = (from) => {
    if (from === "catalog") {
      distributorProfileContext.setSelectedTab(TABS.CATALOG);
      catalogContext.setSelectedTab(TABS.CATALOG_INFORMATION);
      catalogContext.setCatalogMode(MODE.ADD);
      catalogContext.setCatalogId(0);
      catalogContext.copyCatalog({ contentId: catalogId });
      setCatalogMode(MODE.ADD);
      setCatalogId(0);
    } else if (from === "bundle") {
      distributorProfileContext.setSelectedTab(TABS.BUNDLE);
      bundleContext.setSelectedTab(TABS.BUNDLE_INFORMATION);
      bundleContext.setBundleMode(MODE.ADD);
      bundleContext.setBundleId(0);
      bundleContext.copyBundle({ contentId: bundleId });
      setBundleMode(MODE.ADD);
      setBundleId(0);
    } else {
      distributorProfileContext.setSelectedTab(TABS.CONTENT);
      contentContext.setSubSelectedTab(TABS.CONTENT_INFORMATION);
      contentContext.setContentMode(MODE.ADD);
      contentContext.setContentId(0);
      contentContext.copyContent({ contentId: contentId });
      setContentMode(MODE.ADD);
      setContentId(0);
    }
  };

  const onSaveHandler = (from, content) => {
    if (from === "catalog") {
      setCatalogMode(MODE.LIST);
      catalogContext.setCatalogMode(MODE.LIST);
      history.push(`/distributor/${content.userId}/catalog`);
    } else if (from === "bundle") {
      setBundleMode(MODE.LIST);
      bundleContext.setBundleMode(MODE.LIST);
      history.push(`/distributor/${content.userId}/bundle`);
    } else {
      setContentMode(MODE.LIST);
      contentContext.setContentMode(MODE.LIST);
      history.push(`/distributor/${content.userId}/content`);
    }
  };

  const onCancelHandler = (from = "") => {
    if (from === "catalog") {
      setCatalogMode(MODE.LIST);
      catalogContext.setCatalogMode(MODE.LIST);
      catalogContext.resetCopyCatalog();
    } else if (from === "bundle") {
      setBundleMode(MODE.LIST);
      bundleContext.setBundleMode(MODE.LIST);
      bundleContext.resetCopyBundle();
    } else {
      setContentMode(MODE.LIST);
      contentContext.setContentMode(MODE.LIST);
      contentContext.resetCopyContent();
      history.push(
        `${history.location.pathname.substring(
          0,
          history.location.pathname.indexOf("content"),
        )}${TABS.CONTENT}`,
      );
    }
  };

  const onContentSaveNextHandler = (action, value, from = "") => {
    if (from === "catalog") {
      distributorProfileContext.setSelectedTab(TABS.CATALOG);
      if (action === "Update") {
        catalogContext.setSelectedTab(TABS.ENROLLED_USERS);
      } else {
        catalogContext.setSelectedTab(TABS.CONTENT_LIST);
      }
      history.push(`/distributor/${id}/catalog/${TABS.CONTENT_LIST}`);
      if (action === "Save") {
        catalogContext.setCatalogMode(MODE.EDIT);
        setCatalogMode(MODE.VIEW);
      }
      catalogContext.setCatalogId(value);
      setCatalogId(value);
    } else if (from === "bundle") {
      distributorProfileContext.setSelectedTab(TABS.BUNDLE);
      if (action === "Update") {
        bundleContext.setSelectedTab(TABS.ENROLLED_USERS);
      } else {
        bundleContext.setSelectedTab(TABS.CONTENT_LIST);
      }
      history.push(`/distributor/${id}/bundle/${TABS.CONTENT_LIST}`);
      if (action === "Save") {
        bundleContext.setBundleMode(MODE.EDIT);
        setBundleMode(MODE.VIEW);
      }
      bundleContext.setBundleId(value);
      setBundleId(value);
    } else {
      distributorProfileContext.setSelectedTab(TABS.CONTENT);
      contentContext.setSelectedTab(TABS.CONTENT_PREVIEW);
      if (action === "Save") {
        contentContext.setContentMode(MODE.VIEW);
        setContentMode(MODE.VIEW);
      }
      history.push(`/distributor/${id}/content/${TABS.CONTENT_PREVIEW}`);
      contentContext.setContentId(value);
      setContentId(value);
    }
  };

  const { userTypeId, profileTabs = [] } = props.routeData;

  const baseTabs = userTypeId === 4 ? [...profileTabs] : profileTabs;
  // Tabs flagged with `isPermissionRequired` are only rendered when the user
  // has the `List` permission on the tab's own moduleId (e.g. Ads moduleId 68).
  const tabs = baseTabs.filter(
    (tab) =>
      !tab.isPermissionRequired ||
      hasModulePermission(tab.moduleId, PermissionEnum.LIST),
  );
  const moduleId = getModuleId(userTypeId);
  const currentUserId = auth.getCurrentUser()?.userId;

  const allowedModules = enabledTabs(moduleId);

  /* Advertisement tab gating: when the logged-in user's role is
   * Distributor the tab is only visible on their OWN profile. Admin /
   * Super Admin (and any other role) can view it on any distributor
   * profile as before. Extracted to keep the filter predicate flat */

  const isAdManagementTabVisible = (tab) => {
    if (tab.idDisplay !== "ad-management-tab") return true;
    if (roleId !== SystemUsersEnum.DISTRIBUTOR) return true;
    return id?.toString() === currentUserId?.toString();
  };

  // Add-ins tab is visible to Admin/Super Admin on all profiles.
  // Enterprise users can access it only on their own profile.
  const isAddInsTabVisible = (tab) => {
    if (tab.idDisplay !== "addins-tab") return true;
    if (isSuperAdminOrAdminRole(roleId)) return true;
    if (!isEnterpriseUserRole(roleId)) return false;
    return id?.toString() === currentUserId?.toString();
  };

  const visibleTabs = tabs.filter(
    (item) =>
      (item.isMock || allowedModules?.includes(item.module_name)) &&
      isAddInsTabVisible(item) &&
      isAdManagementTabVisible(item),
  );
  const whenUserTypeNot4 =
    props?.routeData?.userTypeId === 3 ? (
      <CreateDistributorModal
        routeData={props.routeData}
        formData={formData}
        onNext={onNextHandler}
        isEditMode={page.isEditMode}
        permissions={permissions}
        PermissionEnum={PermissionEnum}
        getEditData={getEditData}
        basicDetailPermission={childModulePermissions(
          getModuleId(props?.routeData?.userTypeId),
          SystemModulesEnum.DISTRIBUTOR_PROFILE_BASIC_DETAILS,
        )}
        associationDetailsPermission={childModulePermissions(
          getModuleId(props?.routeData?.userTypeId),
          SystemModulesEnum.DISTRIBUTOR_PROFILE_ASSOCIATION_DETAILS,
        )}
        subscriptionDetailsPermission={childModulePermissions(
          getModuleId(props?.routeData?.userTypeId),
          SystemModulesEnum.DISTRIBUTOR_PROFILE_SUBSCRIPTION_DETAILS,
        )}
      />
    ) : (
      // for subscriber module
      <CreateDistributorModal
        routeData={props.routeData}
        formData={formData}
        onNext={onNextHandler}
        isEditMode={page.isEditMode}
        permissions={permissions}
        PermissionEnum={PermissionEnum}
        getEditData={getEditData}
        basicDetailPermission={PermissionService(props?.routeData?.moduleId)}
        associationDetailsPermission={PermissionService(
          props?.routeData?.moduleId,
        )}
      />
    );
  return (
    <Grid spacing={0} container className="distributor-container">
      <Grid
        spacing={0}
        container
        className="distributor-profile-form custom-width"
      >
        <Grid item xs={12}>
          <BasicInfo
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            id={id}
            options={internalFilterOptions}
            internalFilterOptions={internalFilterOptions}
            contentContext={contentContext}
            useBundleContext={useBundleContext}
            setContentId={setContentId}
            setBundleId={setBundleId}
            setCatalogId={setCatalogId}
            useContentContext={useContentContext}
            useCatalogContext={useCatalogContext}
            catalogContext={catalogContext}
            bundleContext={bundleContext}
            contentMode={contentMode}
            catalogMode={catalogMode}
            bundleMode={bundleMode}
            applytypecontentFilterHandler={applytypecontentFilterHandler}
            typecontentListOptions={typecontentListOptions}
            settypecontentListOptions={settypecontentListOptions}
            setBundleMode={setBundleMode}
            setCatalogMode={setCatalogMode}
            setContentMode={setContentMode}
            contentFilterOptions={contentFilterOptions}
            catalogFilterOptions={catalogFilterOptions}
            bundleFilterOptions={bundleFilterOptions}
            setContentFilterOptions={setContentFilterOptions}
            setSelectedSubTab={setSelectedSubTab}
            setCatalogFilterOptions={setCatalogFilterOptions}
            setBundleFilterOptions={setBundleFilterOptions}
            createUserView={createUserView}
            setCreateUserView={setCreateUserView}
            tableColumnModalVisibility={tableColumnModalVisibility}
            tableColumnModalVisibilityInternal={
              tableColumnModalVisibilityInternal
            }
            loadDropndownOption={loadDropndownOption}
            setTableColumnModalVisibilityInternal={
              setTableColumnModalVisibilityInternal
            }
            setTableColumnModalVisibility={setTableColumnModalVisibility}
            currentUser={currentUser}
            handleClick={handleClick}
            PermissionEnum={PermissionEnum}
            open={open}
            selectedTab={selectedTab}
            tabPermissions={tabPermissions}
            allUsersExportPermission={allUsersExportPermission}
            selectedSubTab={selectedSubTab}
            setSelectedTab={setSelectedTab}
            location={location}
            bulkUploadTemplate={bulkUploadTemplate}
            onCopyHandler={onCopyHandler}
            handleExport={handleExport}
            bulkUploadHandler={bulkUploadHandler}
            applyContentFilterHandler={applyContentFilterHandler}
            handleHandleChange={handleHandleChange}
            applyInternalFilterHandler={applyInternalFilterHandler}
            handleClose={handleClose}
            formData={formData}
            TABS={TABS}
            validateBasicInformation={validateBasicInformationBeforeCreate}
            onContinueToUpdateBasicInfo={handleContinueToUpdateBasicInfo}
            adManagementFilterOptions={adManagementFilterOptions}
            applyAdManagementFilterHandler={applyAdManagementFilterHandler}
            onAddAdManagement={() => setAdManagementTriggerAdd(true)}
            isAdManagementFormOpen={adManagementMode !== MODE.LIST}
          />
        </Grid>
        <Grid
          spacing={3}
          item
          container
          marginLeft={1}
          marginRight={1}
          marginTop={0}
          className="custom-width"
        >
          <Grid
            item
            md={9}
            lg={11}
            sm={12}
            xs={12}
            className="distributor-profile-form custom-marginleft custom-width-box position-fix-panel"
          >
            <Box
              p={1}
              mr={4}
              className="right-section"
              sx={{ borderBottom: 1, borderColor: "divider" }}
            >
              <Tabs
                value={selectedTab}
                onChange={handleHandleChange}
                aria-label="Distributor Tabs"
              >
                {visibleTabs.map((item) => (
                  <Tab
                    key={item.id}
                    className="my-tabs"
                    label={item.name}
                    value={item.label}
                    {...a11yProps(item.label, item.label)}
                    disabled={item.disabled}
                  />
                ))}

                {userTypeId === SystemUsersEnum.SUBSCRIBER && (
                  <Tab
                    className="my-tabs"
                    label="Access Details"
                    value={TABS.ACCESSDETAILS}
                    {...a11yProps("Access Details", "Access Details")}
                    disabled={false}
                  />
                )}
              </Tabs>

              <TabPanel
                value={selectedTab}
                index={TABS.BASIC}
                className="distributor-tab-panel"
              >
                {props?.routeData?.userTypeId === 4 ? (
                  <CreateEnterpriseModal
                    routeData={props.routeData}
                    formData={formData}
                    onNext={onNextHandler}
                    isEditMode={page.isEditMode}
                    permissions={permissions}
                    PermissionEnum={PermissionEnum}
                    getEditData={getEditData}
                    basicDetailPermission={childModulePermissions(
                      getModuleId(props?.routeData?.userTypeId),
                      SystemModulesEnum.ENTERPRISE_PROFILE_BASIC_DETAILS,
                    )}
                    associationDetailsPermission={childModulePermissions(
                      getModuleId(props?.routeData?.userTypeId),
                      SystemModulesEnum.ENTERPRISE_PROFILE_ASSOCIATION_DETAILS,
                    )}
                  />
                ) : (
                  whenUserTypeNot4
                )}
              </TabPanel>

              {props.routeData.userTypeId === SystemUsersEnum.SUBSCRIBER && (
                <TabPanel
                  value={selectedTab}
                  index={TABS.ACCESSDETAILS}
                  className="distributor-tab-panel"
                >
                  <Access
                    id={id}
                    permissions={tabPermissions}
                    routeData={props.routeData}
                    query={contentQuery}
                  />
                </TabPanel>
              )}

              {childModulePermissions(
                getModuleId(props?.routeData?.userTypeId),
                props?.routeData?.userTypeId === SystemUsersEnum.DISTRIBUTOR ||
                  props?.routeData?.userTypeId ===
                    SystemUsersEnum.DISTRIBUTOR_INTERNAL
                  ? SystemModulesEnum.DISTRIBUTOR_INTERNAL_USER
                  : SystemModulesEnum.ENTERPRISE_INTERNAL_USER,
              )?.includes(PermissionEnum.LIST) && (
                <TabPanel value={selectedTab} index={TABS.INTERNAL_USERS}>
                  {createUserView && id && (
                    <AddEditInternalUserModal
                      routeData={props.routeData}
                      onSuccess={setRefreshCallBack}
                      data={addInternalUserFormData}
                      distributorData={formData}
                      userRolesDropdown={userRoles}
                      handleCloseModalCallback={handleCloseModalCallback}
                      permissions={tabPermissions}
                    />
                  )}
                  <InternalUsers
                    searchCallback={searchCallback}
                    routeData={props.routeData}
                    id={id}
                    query={query}
                    distributorData={formData}
                    userRolesDropdown={userRoles}
                    isRefresh={refreshData}
                    onSuccess={setRefreshCallBack}
                    showColumnPopup={tableColumnModalVisibilityInternal}
                    onCancelTableColumnSelection={
                      onCancelTableColumnSelectionInternal
                    }
                    permissions={tabPermissions}
                  />
                </TabPanel>
              )}

              {childModulePermissions(
                getModuleId(props?.routeData?.userTypeId),
                props?.routeData?.userTypeId === SystemUsersEnum.DISTRIBUTOR ||
                  props?.routeData?.userTypeId ===
                    SystemUsersEnum.DISTRIBUTOR_INTERNAL
                  ? SystemModulesEnum.DISTRIBUTOR_CONTENT
                  : SystemModulesEnum.ENTERPRISE_CONTENT,
              )?.includes(PermissionEnum.LIST) && (
                <TabPanel
                  value={selectedTab}
                  index={TABS.CONTENT}
                  className="distributor-tab-panel"
                >
                  <Content
                    id={id}
                    distributorId={formData?.systemGeneratedId}
                    signUpApproval={formData?.signUpApproval}
                    contentId={contentId}
                    mode={contentMode}
                    query={contentQuery}
                    onView={onViewHandler}
                    setSelectedSubTab={setSelectedSubTab}
                    onEdit={onEditHandler}
                    onQueryChange={onQueryChange}
                    onSave={onSaveHandler}
                    onCancel={onCancelHandler}
                    onNext={onContentSaveNextHandler}
                    showColumnPopup={tableColumnModalVisibility}
                    onCancelTableColumnSelection={onCancelTableColumnSelection}
                    isMassUploadPermission={childModulePermissions(
                      getModuleId(props?.routeData?.userTypeId),
                      SystemModulesEnum.DISTRIBUTOR_CONTENT,
                    )?.includes(PermissionEnum.CREATE)}
                    permissions={tabPermissions}
                    setContentOriginators={setContentOriginators}
                    routeData={props.routeData}
                  />
                </TabPanel>
              )}

              {childModulePermissions(
                getModuleId(props?.routeData?.userTypeId),
                props?.routeData?.userTypeId === SystemUsersEnum.DISTRIBUTOR ||
                  props?.routeData?.userTypeId ===
                    SystemUsersEnum.DISTRIBUTOR_INTERNAL
                  ? SystemModulesEnum.DISTRIBUTOR_CATALOG
                  : SystemModulesEnum.ENTERPRISE_CATALOG,
              )?.includes(PermissionEnum.LIST) && (
                <TabPanel
                  value={selectedTab}
                  index={TABS.CATALOG}
                  className="distributor-tab-panel"
                >
                  <Catalog
                    id={id}
                    distributorId={formData?.systemGeneratedId}
                    signUpApproval={formData?.signUpApproval}
                    catalogId={catalogId}
                    mode={catalogMode}
                    query={contentQuery}
                    onView={onViewHandler}
                    setSelectedSubTab={setSelectedSubTab}
                    onSave={onSaveHandler}
                    onCancel={onCancelHandler}
                    onNext={onContentSaveNextHandler}
                    onEdit={onEditHandler}
                    onQueryChange={onQueryChange}
                    showColumnPopup={tableColumnModalVisibility}
                    onCancelTableColumnSelection={onCancelTableColumnSelection}
                    applyContentFilterHandler={applyContentFilterHandler}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    permissions={tabPermissions}
                    setContentId={setContentId}
                    setContentMode={setContentMode}
                    routeData={props.routeData}
                  />
                </TabPanel>
              )}

              {childModulePermissions(
                getModuleId(props?.routeData?.userTypeId),
                props?.routeData?.userTypeId === SystemUsersEnum.DISTRIBUTOR ||
                  props?.routeData?.userTypeId ===
                    SystemUsersEnum.DISTRIBUTOR_INTERNAL
                  ? SystemModulesEnum.DISTRIBUTOR_BUNDLE
                  : SystemModulesEnum.ENTERPRISE_BUNDLE,
              )?.includes(PermissionEnum.LIST) && (
                <TabPanel
                  value={selectedTab}
                  index={TABS.BUNDLE}
                  className="distributor-tab-panel"
                >
                  <Bundle
                    id={id}
                    distributorId={formData?.systemGeneratedId}
                    signUpApproval={formData?.signUpApproval}
                    catalogId={bundleId}
                    mode={bundleMode}
                    query={contentQuery}
                    onView={onViewHandler}
                    onViewHandlerList={onViewHandlerList}
                    onEditHandlerList={onEditHandlerList}
                    setSelectedSubTab={setSelectedSubTab}
                    onSave={onSaveHandler}
                    onCancel={onCancelHandler}
                    onNext={onContentSaveNextHandler}
                    onEdit={onEditHandler}
                    onQueryChange={onQueryChange}
                    showColumnPopup={tableColumnModalVisibility}
                    onCancelTableColumnSelection={onCancelTableColumnSelection}
                    permissions={tabPermissions}
                    setContentId={setContentId}
                    setContentMode={setContentMode}
                    setBundleId={setBundleId}
                    setBundleMode={setBundleMode}
                    setCatalogId={setCatalogId}
                    setCatalogMode={setCatalogMode}
                    routeData={props.routeData}
                  />
                </TabPanel>
              )}

              {props.routeData.userTypeId === SystemUsersEnum.DISTRIBUTOR && (
                <TabPanel
                  value={selectedTab}
                  index={TABS.ADDINS}
                  className="distributor-tab-panel"
                >
                  <AddInsServicesList
                    id={id}
                    distributorId={formData?.systemGeneratedId}
                    signUpApproval={formData?.signUpApproval}
                    catalogId={catalogId}
                    mode={catalogMode}
                    query={contentQuery}
                    onView={onViewHandler}
                    setSelectedSubTab={setSelectedSubTab}
                    onSave={onSaveHandler}
                    onCancel={onCancelHandler}
                    onNext={onContentSaveNextHandler}
                    onEdit={onEditHandler}
                    onQueryChange={onQueryChange}
                    showColumnPopup={tableColumnModalVisibility}
                    onCancelTableColumnSelection={onCancelTableColumnSelection}
                    applyContentFilterHandler={applyContentFilterHandler}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    permissions={tabPermissions}
                    setContentId={setContentId}
                    setContentMode={setContentMode}
                    routeData={props.routeData}
                  />
                </TabPanel>
              )}

              {props.routeData.userTypeId === SystemUsersEnum.DISTRIBUTOR && (
                <TabPanel
                  value={selectedTab}
                  index={TABS.AD_MANAGEMENT}
                  className={`distributor-tab-panel${selectedTab === TABS.AD_MANAGEMENT ? " distributor-tab-panel--full-height" : ""}`}
                >
                  <AdManagementList
                    id={id}
                    query={adManagementQuery}
                    setQuery={setAdManagementQuery}
                    showColumnPopup={tableColumnModalVisibility}
                    onCancelTableColumnSelection={onCancelTableColumnSelection}
                    permissions={tabPermissions}
                    triggerAdd={adManagementTriggerAdd}
                    onTriggerAddHandled={() => setAdManagementTriggerAdd(false)}
                    onModeChange={setAdManagementMode}
                  />
                </TabPanel>
              )}

              {props.routeData.userTypeId === 4 &&
                selectedTab === "add-ins" && (
                  <TabPanel
                    value={selectedTab}
                    index="add-ins"
                    className="distributor-tab-panel"
                  >
                    <AddInsServicesTab
                      permissions={tabPermissions}
                      routeData={props.routeData}
                    />
                  </TabPanel>
                )}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
DistributorProfile.propTypes = {
  routeData: PropTypes.shape({
    bulkUploadTemplate: PropTypes.string,
    userTypeId: PropTypes.number,
    title: PropTypes.string,
    listRoute: PropTypes.string,
    userRolesKey: PropTypes.string,
    editRoute: PropTypes.string,
    moduleId: PropTypes.number,
    queryVar: PropTypes.string,
    internalUserTypeId: PropTypes.number,
    schema: PropTypes.object,
    basicInformationSchema: PropTypes.object,
    profileTabs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        label: PropTypes.string,
        disabled: PropTypes.bool,
        module_name: PropTypes.string,
      }),
    ),
  }).isRequired,
};

DistributorProfile.defaultProps = {
  routeData: {
    bulkUploadTemplate: "",
    userTypeId: 0,
    title: "",
    listRoute: "",
    userRolesKey: "",
    editRoute: "",
    moduleId: 0,
    queryVar: "",
    internalUserTypeId: 0,
    schema: null,
    basicInformationSchema: null,
    profileTabs: [],
  },
};
export default DistributorProfile;
/*istanbul ignore next */
function switchByTab(selectedTab, userPathRole) {
  let selectedSubModule;
  switch (selectedTab) {
    case TABS.INTERNAL_USERS:
      selectedSubModule = tabinternalUsers(userPathRole, selectedSubModule);
      break;
    /*istanbul ignore next */
    case TABS.CONTENT:
      selectedSubModule = tabContent(userPathRole, selectedSubModule);
      break;
    case TABS.CATALOG:
      selectedSubModule = tabCatalog(userPathRole, selectedSubModule);
      break;
    case TABS.BUNDLE:
      selectedSubModule = tabBundle(userPathRole, selectedSubModule);
      break;
    case TABS.AD_MANAGEMENT:
      selectedSubModule = SystemModulesEnum.ADS;
      break;
    case TABS.BASIC:
    default:
      if (userPathRole) {
        selectedSubModule = SystemModulesEnum.DISTRIBUTOR_PROFILE_BASIC_DETAILS;
      } else {
        selectedSubModule = SystemModulesEnum.ENTERPRISE_PROFILE_BASIC_DETAILS;
      }
      break;
  }
  return selectedSubModule;
}

function tabBundle(userPathRole, selectedSubModule) {
  /*istanbul ignore next */
  if (userPathRole) {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.DISTRIBUTOR_BUNDLE;
  } else {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.ENTERPRISE_BUNDLE;
  }
  return selectedSubModule;
}

function tabCatalog(userPathRole, selectedSubModule) {
  /*istanbul ignore next */
  if (userPathRole) {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.DISTRIBUTOR_CATALOG;
  } else {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.ENTERPRISE_CATALOG;
  }
  return selectedSubModule;
}

function tabContent(userPathRole, selectedSubModule) {
  /*istanbul ignore next */
  if (userPathRole) {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.DISTRIBUTOR_CONTENT;
  } else {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.ENTERPRISE_CONTENT;
  }
  return selectedSubModule;
}

function tabinternalUsers(userPathRole, selectedSubModule) {
  /*istanbul ignore next */
  if (userPathRole) {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.DISTRIBUTOR_INTERNAL_USER;
  } else {
    /*istanbul ignore next */
    selectedSubModule = SystemModulesEnum.ENTERPRISE_INTERNAL_USER;
  }
  return selectedSubModule;
}
/*istanbul ignore next */
function getPathRole(roleId, props) {
  return (roleId === SystemUsersEnum.DISTRIBUTOR ||
    roleId === SystemUsersEnum.DISTRIBUTOR_INTERNAL ||
    roleId === SystemUsersEnum.SUPERADMIN ||
    roleId === SystemUsersEnum.ADMIN) &&
    props.routeData?.title === UserTypes.distributor.title
    ? true
    : false;
}
/*istanbul ignore next */
async function updateBySelectTab(dataObj) {
  let exportedContent;
  if (dataObj.selectedTab === TABS.INTERNAL_USERS) {
    dataObj.queryState.filter.selectedColumns = GetSelectedColumns(
      dataObj.props?.routeData?.internalUserTypeId,
    );
    exportedContent = await dataObj.userService.exportDataInternalUsers(
      `?${dataObj.props.routeData.queryVar}=${
        dataObj.id
      }&query=${JSON.stringify(dataObj.queryState)}`,
    );
  } else if (dataObj.selectedTab === TABS.CONTENT) {
    exportedContent = await onTabContent(
      dataObj.id,
      dataObj.contentId,
      dataObj.selectedSubTab,
      dataObj.queryState,
      exportedContent,
      dataObj.userService,
    );
  } else if (dataObj.selectedTab === TABS.CATALOG) {
    exportedContent = await onTabCatalog(dataObj, exportedContent);
  } else if (dataObj.selectedTab === TABS.BUNDLE) {
    exportedContent = await onTabBundle(dataObj, exportedContent);
  }
  return exportedContent;
}
/*istanbul ignore next */
function tabSelections(selectedTab, selectedCols, queryState) {
  const whenNotContent =
    selectedTab === TABS.CATALOG ? selectedCols?.catalog : whenNotCatalog();
  return selectedTab === TABS.CONTENT ? selectedCols?.contents : whenNotContent;

  function whenNotCatalog() {
    return selectedTab === TABS.BUNDLE
      ? selectedCols?.bundle
      : queryState.filter.selectedColumns;
  }
}
/*istanbul ignore next */
async function onTabCatalog(dataObj, exportedContent) {
  const {
    id,
    catalogId,
    selectedSubTab,
    queryState,
    userService,
    catalogContext,
  } = dataObj;
  let firstParam = 0;
  let secondParam = 0;
  let firstParamAssociated = 0;
  let secondParamAssociated = 0;

  if (window.location.pathname.includes("distributor")) {
    firstParam = Number(id);
    secondParam = catalogId;
    firstParamAssociated = Number(id);
    secondParamAssociated = catalogId;
  } else if (window.location.pathname.includes("enterprisegroup")) {
    firstParam = -1;
    secondParam = Number(id);
    firstParamAssociated = catalogContext.userId
      ? catalogContext.userId
      : Number(id);
    secondParamAssociated = catalogId;
  }
  let selectedCols = localStorage.getItem("selectedColumns")
    ? JSON.parse(localStorage.getItem("selectedColumns"))
    : null;
  if (selectedSubTab === "ContentList") {
    queryState.filter.selectedColumns = getSelectedCols(
      selectedCols,
      "listOfContentCatalogDataColumns",
    );
    exportedContent = await userService.exportAssociatedDataCatalog(
      `${firstParamAssociated}/${secondParamAssociated}/${encodeURIComponent(
        JSON.stringify(queryState),
      )}`,
    );
  } else {
    queryState.filter.selectedColumns = getSelectedCols(
      selectedCols,
      "catalog",
    );
    exportedContent = await userService.exportDataCatalog(
      `${firstParam}/${secondParam}/${encodeURIComponent(
        JSON.stringify(queryState),
      )}`,
    );
  }
  return exportedContent;
}
/*istanbul ignore next */
async function onTabBundle(dataObj, exportedContent) {
  const {
    id,
    bundleId,
    selectedSubTab,
    queryState,
    userService,
    bundleContext,
  } = dataObj;

  let firstParam = 0;
  let secondParam = 0;
  let firstParamAssociated = 0;
  let secondParamAssociated = 0;

  if (window.location.pathname.includes("distributor")) {
    firstParam = Number(id);
    secondParam = bundleId;
    firstParamAssociated = Number(id);
    secondParamAssociated = bundleId;
  } else if (window.location.pathname.includes("enterprisegroup")) {
    firstParam = -1;
    secondParam = Number(id);
    firstParamAssociated = bundleContext.userId
      ? bundleContext.userId
      : Number(id);
    secondParamAssociated = bundleId;
  }
  let selectedCols = localStorage.getItem("selectedColumns")
    ? JSON.parse(localStorage.getItem("selectedColumns"))
    : null;
  if (selectedSubTab === "ContentList") {
    queryState.filter.selectedColumns = getSelectedCols(
      selectedCols,
      "listcustombundledatacolumns",
    );
    exportedContent = await userService.exportAssociatedDataBundle(
      `${firstParamAssociated}/${secondParamAssociated}/${encodeURIComponent(
        JSON.stringify(queryState),
      )}`,
    );
  } else {
    queryState.filter.selectedColumns = getSelectedCols(selectedCols, "bundle");
    exportedContent = await userService.exportDataBundle(
      `${firstParam}/${secondParam}/${encodeURIComponent(
        JSON.stringify(queryState),
      )}`,
    );
  }
  return exportedContent;
}
/*istanbul ignore next */
async function onTabContent(
  id,
  contentId,
  selectedSubTab,
  queryState,
  exportedContent,
  userService,
) {
  let firstParam = 0;
  let secondParam = 0;
  if (window.location.pathname.includes("distributor")) {
    firstParam = Number(id);
    secondParam = contentId;
  } else if (window.location.pathname.includes("enterprisegroup")) {
    firstParam = -1;
    secondParam = Number(id);
  }
  let selectedCols = localStorage.getItem("selectedColumns")
    ? JSON.parse(localStorage.getItem("selectedColumns"))
    : null;
  if (selectedSubTab === "ContentList") {
    queryState.filter.selectedColumns = getSelectedCols(
      selectedCols,
      "listOfContentCatalogDataColumns",
    );
    exportedContent = await userService.exportDataContent(
      `${firstParam}/${secondParam}/${encodeURIComponent(
        JSON.stringify(queryState),
      )}`,
    );
  } else {
    queryState.filter.selectedColumns = getSelectedCols(
      selectedCols,
      "distributorContent",
    );
    exportedContent = await userService.exportDataContent(
      `${firstParam}/${secondParam}/${encodeURIComponent(
        JSON.stringify(queryState),
      )}`,
    );
  }
  return exportedContent;
}
